import { smoothScroll as smoothScrollUtility } from '../../utilities';

const validateProperties = (properties) => {
  const requiredProperties = ['focus', 'target'];
  const throwError = (missingProperties) => {
    throw new Error(`Missing properties to set up scroll directive: ${missingProperties.join(', ')}`);
  };

  // Check if properties object is present
  if (!properties || typeof properties !== 'object') {
    throwError(requiredProperties);
  }

  const propKeys = Object.keys(properties);
  const propValues = Object.values(properties);

  // Check if all required properties are provided
  if (!requiredProperties.every((prop) => prop in properties)) {
    throwError(requiredProperties.filter((prop) => !propKeys.includes(prop)));
  }

  // Check if some required property is empty
  const isEmpty = (prop) => prop === '';
  if (propValues.some(isEmpty)) {
    const invalidProp = propKeys[propValues.findIndex(isEmpty)];
    throw new Error(`Property ${invalidProp} is empty`);
  }
};

export const smoothScroll = {
  name: 'smoothScroll',

  bind: (el, binding) => {
    validateProperties(binding && binding.value);

    el.addEventListener('click', () => {
      smoothScrollUtility(document.querySelector(binding.value.target));
      document.querySelector(binding.value.focus).focus();
    });
  },

  unbind: (el, binding) => {
    el.removeEventListener('click', () => {
      smoothScrollUtility(document.querySelector(binding.value.target));
      document.querySelector(binding.value.focus).focus();
    });
  },
};
